"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledAppInfoModal = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// External
var StyledAppInfoModal = _styledComponents.default.div.withConfig({
  displayName: "AppInfoModalstyles__StyledAppInfoModal",
  componentId: "sc-459jpd-0"
})(["display:", ";position:fixed;top:0;left:0;bottom:0;right:0;justify-content:center;align-content:center;align-items:center;z-index:", ";background:", ";.innerWrapper{max-width:40%;border-radius:", ";background-color:", ";padding:1rem;max-height:75%;overflow:hidden;display:flex;flex-direction:column;}.infoHeader{background-color:", ";border-radius:", ";position:relative;padding:", ";margin-bottom:1rem;}.title{color:", ";margin:0 auto;text-align:center;}.closeButton{background-color:", ";right:", ";position:absolute;top:", ";border-radius:", ";width:1.5rem;cursor:pointer;}.data{background-color:", ";padding:1rem;border-radius:", ";overflow:auto;}.ourLibs{margin-left:", ";}"], function (props) {
  return props.isVisible ? 'flex' : 'none';
}, function (props) {
  return props.theme.modal;
}, function (props) {
  return props.theme.c_mask_modal;
}, function (props) {
  return props.theme.borderRadius;
}, function (props) {
  return props.theme.c_foreground_gridLines;
}, function (props) {
  return props.theme.c_background_default;
}, function (props) {
  return props.theme.borderRadius;
}, function (props) {
  return props.theme.infoPadding;
}, function (props) {
  return props.theme.c_foreground_default;
}, function (props) {
  return props.theme.c_foreground_gridLines;
}, function (props) {
  return props.theme.infoPadding;
}, function (props) {
  return props.theme.infoPadding;
}, function (props) {
  return props.theme.borderRadius;
}, function (props) {
  return props.theme.c_background_default;
}, function (props) {
  return props.theme.borderRadius;
}, function (props) {
  return props.theme.infoPadding;
});

exports.StyledAppInfoModal = StyledAppInfoModal;